import axios from 'axios'
export const http = () =>
  axios.create({
    baseURL: process.env.API_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
// console.log('HTTP', http);

// window.http = http

// // Add a response interceptor
// http.interceptors.response.use(function (response) {
//     // Do something with response data
//     console.log(`Response from interceptor:${response}`)
//     return response;
//   }, function (error) {
//     // Do something with response error

//     return Promise.reject(error);
//   });



// WEBPACK FOOTER //
// ./src/services/http.js